import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import GridWrapper from '../../../../components/controls/GridWrapper';
import styles from '../styles/GosContractGrid.module.scss'
import { debounce } from 'lodash';
import { GridFilterAction } from '../../../../system/hooks/useGridFilter';
import { Input, Tooltip } from 'antd';
import { SearchIcon } from '../../../../libs/corporate/icons/outlined/action/MainCollection';


interface GosContractSearchPanelProps {
    dispatchGridFilter: (value: GridFilterAction) => void;
    onFocusChanged?: (taken: boolean) => void;
}
 
const searchFields = [
    ["Name", "Наименование контракта"],
    ["TaskProgram", "Программа"],
    ["FundingSourceName", "Источник финансирования"],
    ["ContractorName", "Заказчик"],
    ["LotNum", "Лот"],
    ["Protokol", "Протокол"],
    ["Code", "Код"],
];

const MIN_SEARCH_LENGTH = 3;

export const GosContractSearchPanel: FC<GosContractSearchPanelProps> = (props) => {
    const { t } = useTranslation();
    const [searchValue, setSearchValue] = useState<string>('');

    const getSearchFields = useCallback(() => searchFields.map(([field]) => field), []);
    const getTooltipText = useCallback(() => searchFields.map(([, label]) => label).join(', '), []);

    
    const buildSearchQuery = useCallback((value: string): string => {
        return getSearchFields()
            .map(field => `lower("${field}") like lower('%${value.replace(/'/g, "''")}%')`)
            .join(' or ') + `or ("IdGlobal" in (select id_gos_contract_global from core.gos_contract_goods where lower(spec_name) like lower('%${value}%')))`;
    }, [getSearchFields]);

    const search = useCallback((value: string): void => {
        if (value.length >= MIN_SEARCH_LENGTH) {
            props.dispatchGridFilter({
                type: "addCustomWhereExpressionFilter",
                payload: buildSearchQuery(value)
            });
        } else if (value.length === 0) {
            props.dispatchGridFilter({ type: "deleteCustomWhereExpressionFilter" });
        }
    }, [props.dispatchGridFilter, buildSearchQuery]);

    const debouncedSearch = useMemo(() => debounce(search, 1250), [search]);

    useEffect(() => {
        return () => debouncedSearch.cancel();
    }, []);

    useEffect(() => {
        if (searchValue !== '') {
            debouncedSearch(searchValue);
        }else {
            props.dispatchGridFilter({ type: "deleteCustomWhereExpressionFilter" })
        }
    }, [searchValue, debouncedSearch]);

   
    return (
        <GridWrapper cols={2} className={styles.gridWrapper} >
            <Tooltip
                title={getTooltipText() + ', Содержит товар'}
                placement='bottom'
            >
                <Input
                    className="custom-input-withPrefix"
                    style={{ width: 300, margin: 0, alignSelf: 'center' }}
                    value={searchValue}
                    placeholder={t("general.search")}
                    prefix={<SearchIcon />} 
                    onPressEnter={() => {
                        debouncedSearch.cancel();
                        search(searchValue);
                    }}
                    onChange={(e) => {
                        setSearchValue(e.target.value);
                        props.onFocusChanged?.(e.target.value.length > 0);
                    }}
                    onBlur={() => {
                        props.onFocusChanged?.(false);
                    }}
                    allowClear
                />
            </Tooltip>
        </GridWrapper>
    )
}
